export default __webpack_public_path__ + "static/media/invite_details_arrow_closed_over.66d9bc0d.svg";